import { render, staticRenderFns } from "./hospital_limit.vue?vue&type=template&id=42d3fe1a"
import script from "./hospital_limit.vue?vue&type=script&lang=js"
export * from "./hospital_limit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports